import { GetStaticProps, NextPage } from 'next';
import { serialize } from 'next-mdx-remote/serialize';
import remarkGfm from 'remark-gfm';

import { content } from '~/content';
import { useContent } from '~/hooks';
import { defaultLocale } from '~/i18n';
import { SimpleTemplate } from '~/templates';

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      context: {
        content: {
          privacy: await serialize(
            content.en.privacy,
            {
              mdxOptions: {
                remarkPlugins: [remarkGfm],
              },
            },
          ),
        },
        locale: defaultLocale,
      },
    },
  };
};

const PrivacyPage: NextPage = () => {
  const privacy = useContent()?.privacy;
  if (!privacy) return null;
  return (
    <SimpleTemplate content={privacy} />
  );
};

export default PrivacyPage;
